import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";

export const generateMcqs = createAsyncThunk(
    "ai/generatemcqs",
    async (requestBody:any, { rejectWithValue }) => {
      try {
        const response = await server.post(`/ai_mcq/generate`,requestBody, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message || "Something went wrong")
      }
    }
  );

  export const submitMcqs = createAsyncThunk(
    "ai/submitmcqs",
    async (requestBody:any, { rejectWithValue }) => {
      try {
        const response = await server.post(`/ai_mcq/submit`,requestBody, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message || "Something went wrong")
      }
    }
  );

  export const getScores = createAsyncThunk(
    "ai/getScores",
    async (userId:any, { rejectWithValue }) => {
      try {
        const response = await server.get(`/ai_mcq/score?user_id=${userId}`, {
          headers: {
            "Content-Type": "application/json",
          }
        });
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || error.message || "Something went wrong")
      }
    }
  );
